import { createSlice } from "@reduxjs/toolkit";
import { updateEmergencyHomeVisitOnlineStatus } from "../../reducer/emergencyHomeVisitOnline/updateEmergencyHomeVisitOnlineReducer";

const initialState = {
  isLoading: false,
  data: null,
  error: null,
};

const updateEmergencyHomeVisitOnlineSlice = createSlice({
  name: "updateEmergencyHomeVisitOnline",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateEmergencyHomeVisitOnlineStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(
        updateEmergencyHomeVisitOnlineStatus.fulfilled,
        (state, action) => {
          state.isLoading = false;
          state.data = action.payload?.data || null;
        },
      )
      .addCase(
        updateEmergencyHomeVisitOnlineStatus.rejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.payload || action.error.message;
        },
      );
  },
});

export default updateEmergencyHomeVisitOnlineSlice.reducer;
